<div>
  <form [formGroup]="dateForm">
    <div class="d-flex gap-2">
      <div class="flex-1">
        <finxone-input
          type="number"
          formControlName="day"
          [label]="dataIn.attri.widgetProperties['dayLabel'] ?? 'Day'"
          [value]="dateForm.controls['day']?.value ?? ''"
        ></finxone-input>
      </div>
      <div class="flex-1">
        <finxone-select-dropdown
          [label]="dataIn.attri.widgetProperties['monthLabel'] ?? 'Month'"
          formControlName="month"
          [optionLabelKey]="'name'"
          [optionValueKey]="'key'"
          [options]="allMonths"
          [selectedOption]="selectedMonth?.name ?? ''"
        >
        </finxone-select-dropdown>
      </div>
      <div class="flex-1">
        <finxone-input
          type="number"
          [label]="dataIn.attri.widgetProperties['yearLabel'] ?? 'Year'"
          formControlName="year"
          [value]="dateForm.controls['year']?.value ?? ''"
        ></finxone-input>
      </div>
    </div>
    <!-- Error messages for Day field -->
    <ng-container *ngFor="let validator of dayFieldValidationConfig">
      <small *ngIf="dateForm.controls['day']?.hasError(validator.type)" class="typog-xs text-error">
        {{ getErrorMessage(validator) }}
      </small>
    </ng-container>

    <!-- Error messages for Year field -->
    <ng-container *ngFor="let validator of yearFieldValidationConfig">
      <small *ngIf="dateForm.controls['year']?.hasError(validator.type)" class="typog-xs text-error">
        {{ getErrorMessage(validator) }}
      </small>
    </ng-container>
  </form>
</div>
